import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

import { Metamodel } from '../base/model';
import { ConnectionKind, sanitizeAndFormatString, IAttribute, IModel, TabularTypeDataset } from 'shell-models-lib';

import { AzureCosmosDBLinkedService } from 'app/model/linkedservice/azure-cosmos-db.linkedservice';
import { format, stringIsNullOrEmpty } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.cosmosSql.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.CosmosDb_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.CosmosDb_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AzureCosmosDBLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzureCosmosDbV2Dataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public static DATABASE: IAttribute;

    @Metamodel.attribute({
        display: stringResources.Database,
        templatable: true,
        association: 'DATABASE',
        constraint: {
            validator: (dataset: AzureCosmosDbV2Dataset, database: string) => {
                if (
                    dataset.linkedService?.tridentConnectionKind === ConnectionKind.AZURE_COSMOS_DB_NOSQL_V2 &&
                    stringIsNullOrEmpty(database)
                ) {
                    return [
                        {
                            context: dataset,
                            messageType: 'missing',
                            message: () =>
                                sanitizeAndFormatString(
                                    stringResources.RequiredTemplate,
                                    stringResources.Database
                                )
                        }
                    ];
                }
                return undefined;
            }
        }
    })
    public database?: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
